import { Component, OnInit, Input } from '@angular/core';
import { TourGuideService } from '../../_services/tour-guide.service';
import { VaService } from '../../_services/va.service';
import { TourService } from 'ngx-tour-ng-bootstrap';

@Component({
  selector: 'app-tour-search',
  templateUrl: './tour-search.component.html',
  styleUrls: ['./tour-search.component.scss']
})
export class TourSearchComponent implements OnInit {
  showPopUp = false;
  searchKey: any;
  searchTour: any;
  tourInfo: any;
  @Input() restrict: any;
  public searchResults: Array<any> = [];
  constructor(
    public tourGuideService: TourGuideService,
    public _vaService: VaService,
    public tourService: TourService
    ) { }

  ngOnInit() {
    this.tourGuideService.showSearchPopup.subscribe(res => {
      this.showPopUp = true;
    });
    this.searchFunction("");
  }

  // ngOnDestroy() {
  //   this.tourGuideService.showSearchPopup.unsubscribe();
  // }
  pressCloseButton() {
    this.showPopUp = false;
  }

  searchFunction(searchTour) {
      this._vaService.searchTour(searchTour).subscribe(
        (result: any) => {
          if (!searchTour) {
            this.searchResults = result
          }
          else {
            this.searchResults = result;
          }
          if(this.restrict){
            this.searchResults = this.searchResults.filter(res=>{return res.tour_name=="Create new project"})
          }
          
        });
  }

  getTour(stepId) {
    this._vaService.getTour(stepId).subscribe(
      (result: any) => {
        this.tourService.end();
        this.tourGuideService.currentTour = result.tour_key
        this.updateTourAgent(result['tour_steps'])
      }
    )
  }

  updateTourAgent(steps: any) {
    steps.map(step => {
      if (step.route) {
        const agentId = this._vaService.activeAgent ? this._vaService.activeAgent._id.$oid: undefined;
        const finalRoute = step.route.replaceAll("{AGENT_ID}", agentId)
        step.route = finalRoute
      }
    })
    this.tourService.initialize(steps);
    this.pressCloseButton();
    this.tourService.toggle();
  }
}